(function () {
  'use strict';

  function initMpl(section) {
    var gallery = section.querySelector('[data-mpl-gallery]');
    if (!gallery) return;

    var mainImg = gallery.querySelector('[data-mpl-main-img]');
    var thumbs = gallery.querySelectorAll('[data-mpl-thumb]');
    var dots = gallery.querySelectorAll('[data-mpl-dot-index]');

    function selectImage(idx) {
      var thumb = thumbs[idx];
      if (!thumb || !mainImg) return;
      var src = thumb.getAttribute('data-mpl-src');
      var alt = thumb.getAttribute('data-mpl-alt') || '';
      mainImg.src = src;
      mainImg.alt = alt;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectImage(i); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        selectImage(parseInt(d.getAttribute('data-mpl-dot-index'), 10) || 0);
      });
    });

    /* Description scroll */
    section.querySelectorAll('[data-mpl-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var descEl = section.querySelector('.mpl__desc');
        if (descEl) descEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Quantity */
    var qty = section.querySelector('[data-mpl-qty]');
    var minus = section.querySelector('[data-mpl-qty-minus]');
    var plus = section.querySelector('[data-mpl-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        if (v > 1) { qty.value = v - 1; qty.dispatchEvent(new Event('change')); }
      });
      plus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        var max = parseInt(qty.getAttribute('max'), 10) || 99;
        if (v < max) { qty.value = v + 1; qty.dispatchEvent(new Event('change')); }
      });
    }

    /* Variant pills */
    var pills = section.querySelectorAll('[data-mpl-option-value]');
    var variantIdInput = section.querySelector('[data-mpl-variant-id]');
    var ctaLabel = section.querySelector('[data-mpl-cta-label]');
    var priceEl = section.querySelector('.mpl__price');
    var compareEl = section.querySelector('.mpl__compare');
    var priceRow = section.querySelector('.mpl__price-row');
    var ctaBtn = section.querySelector('.mpl__cta');
    var badgeEl = section.querySelector('.mpl__badge');
    var jsonEl = section.querySelector('[data-mpl-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

    function moneyFmt(cents) {
      if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
      return (cents / 100).toFixed(2);
    }

    function selectedOptions() {
      var selected = {};
      section.querySelectorAll('.mpl__variant').forEach(function (v) {
        var name = null, value = null;
        v.querySelectorAll('[data-mpl-option-value]').forEach(function (p) {
          if (p.classList.contains('is-selected')) {
            name = p.getAttribute('data-mpl-option-name');
            value = p.getAttribute('data-mpl-value');
          }
        });
        if (name) selected[name] = value;
      });
      return selected;
    }

    function findVariant(selected) {
      var wanted = Object.values(selected);
      return variants.find(function (v) {
        return wanted.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function updateSelection() {
      var sel = selectedOptions();
      var variant = findVariant(sel);
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFmt(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) {
          compareEl.textContent = moneyFmt(variant.compare_at_price);
          compareEl.style.display = '';
        } else if (priceRow) {
          var c = document.createElement('span');
          c.className = 'mpl__compare';
          c.textContent = moneyFmt(variant.compare_at_price);
          priceRow.insertBefore(c, priceEl);
        }
        if (badgeEl) {
          var disc = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badgeEl.textContent = disc + '% OFF';
          badgeEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }
      if (ctaBtn) {
        ctaBtn.disabled = !variant.available;
        if (ctaLabel) ctaLabel.textContent = variant.available ? (ctaLabel.dataset.available || 'Add to cart') : 'Sold out';
      }
      /* Update variant image if it has one */
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2');
      }
      /* Update selected label */
      section.querySelectorAll('.mpl__variant').forEach(function (v) {
        var lbl = v.querySelector('[data-mpl-selected-label]');
        var pill = v.querySelector('.mpl__pill.is-selected');
        if (lbl && pill) lbl.textContent = pill.getAttribute('data-mpl-value');
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var name = pill.getAttribute('data-mpl-option-name');
        section.querySelectorAll('[data-mpl-option-name="' + name + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        updateSelection();
      });
    });

    /* Cache initial CTA label for restore on sold-out toggle */
    if (ctaLabel) ctaLabel.dataset.available = ctaLabel.textContent;

    /* Ajax add-to-cart */
    var form = section.querySelector('[data-mpl-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.mpl__cta');
        if (btn) { btn.disabled = true; if (ctaLabel) ctaLabel.textContent = 'Adding...'; }
        var data = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (btn) btn.disabled = false;
            if (ctaLabel) ctaLabel.textContent = 'Added ✓';
            setTimeout(function () { if (ctaLabel) ctaLabel.textContent = ctaLabel.dataset.available || 'Add to cart'; }, 1500);
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            if (ctaLabel) ctaLabel.textContent = ctaLabel.dataset.available || 'Add to cart';
          });
      });
    }
  }

  document.querySelectorAll('.mpl').forEach(initMpl);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.mpl')) {
      e.target.querySelectorAll('.mpl').forEach(initMpl);
    }
  });
})();
